<a class="container_svg" [ngClass]="{'active': isNewMessage, 'fixed': isFixed, 'left': isLeft}" (click)="openChat($event)">
    <svg-icon src="../../../assets/svg/message.svg"></svg-icon>
</a>